import { useEffect } from "react";
import { appDKey } from "../../config";

function AppD() {
  useEffect(() => {
    let appDconfigScript = document.createElement('script');
    appDconfigScript.type = 'text/javascript';
    appDconfigScript.charset = 'UTF-8';
    const scriptContent = `window["adrum-start-time"] = new Date().getTime();
      (function (config) {
        config.appKey = \`${appDKey}\`;
        config.adrumExtUrlHttp = "http://cdn.appdynamics.com";
        config.adrumExtUrlHttps = "https://cdn.appdynamics.com";
        config.beaconUrlHttp = "http://pdx-col.eum-appdynamics.com";
        config.beaconUrlHttps = "https://pdx-col.eum-appdynamics.com";
        config.useHTTPSAlways = true;
        config.resTiming = { "bufSize": 200, "clearResTimingOnBeaconSend": true };
        config.maxUrlLength = 512;
      })(window["adrum-config"] || (window["adrum-config"] = {}));`
    appDconfigScript.textContent = scriptContent;
    document.head.appendChild(appDconfigScript);

    let appDlibScript = document.createElement('script');
    appDlibScript.src = '//cdn.appdynamics.com/adrum/adrum-23.10.1.4359.js';
    document.head.appendChild(appDlibScript);
  }, [])
}

export default AppD;